import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import BasicPageComponent from '../BasicPageComponent';
import ChildGrid from './ChildGrid';

class ProcessTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      departments: [],
    };

  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onClick = (e, name, value) => {
    e.preventDefault();
    this.setState({ [name]: [...value] });
  };

  render() {
    return (
      <div style = {{display: 'flex',height: '100%',
        flexDirection: 'column'}}>
        {/* <SideMenu2/> */}
        <BasicPageComponent
          /*title='SÜREÇ ŞABLONLARI'*/
          /*description='Süreç Şablonları Tanımlama Ekranı'*/
          children = {
            <ScreenContainer>
          <div><ChildGrid {...this.props}/></div>
          </ScreenContainer>
          }
        />
        
      </div>
    );
  }
}

export default (ProcessTemplate);
